/**
 * The external dependencies.
 */
import React from 'react';
import styled from 'styled-components';
/**
 * The internal dependencies.
 */
import NavigationItem from '../../components/home/navigation-item';
import Chevron from '../../components/general/navigation-chevron';
import {ts_translate} from "../../common/clientTranslate";

const Wrapper = styled.div`
	display: flex;
	justify-content: space-between;
	padding: 0 24px;
`;

const NavigationChevron = styled(Chevron)`
	position: absolute;
	top: 9px;
	right: 12px;
`;

const Navigation = () => (
    <Wrapper>
        <NavigationItem to="/dashboard/shop">
            Lieferant

            <NavigationChevron/>
        </NavigationItem>

        <NavigationItem to="/dashboard/shop">
            {ts_translate('Disponent')}

            <NavigationChevron/>
        </NavigationItem>

        <NavigationItem to="/dashboard/shop">
            Qualitätssicherung

            <NavigationChevron/>
        </NavigationItem>

        <NavigationItem to="/dashboard/shop">
            Fertigungsleiter

            <NavigationChevron/>
        </NavigationItem>

        <NavigationItem to="/dashboard/shop">
            Arbeitsplaner

            <NavigationChevron/>
        </NavigationItem>

        <NavigationItem to="/dashboard/shop">
            Konstrukteur

            <NavigationChevron/>
        </NavigationItem>
    </Wrapper>
);

export default Navigation;



// WEBPACK FOOTER //
// ./src/components/home/navigation.js